<script>
	import Router from "svelte-spa-router";
	import Home from "./routes/Home.svelte";
	import ButtonCpts from "./routes/ButtonCpts.svelte";
	import IconCpts from "./routes/IconCpts.svelte";
	import DividerCpts from "./routes/DividerCpts.svelte";
	import IndexBarCpts from "./routes/IndexBarCpts.svelte";
	import AvatarCpts from "./routes/AvatarCpts.svelte";
	import AccordionCpts from "./routes/AccordionCpts.svelte";
	import ToastCpts from "./routes/ToastCpts.svelte";
	import ResultPageCpts from "./routes/ResultPageCpts.svelte";
	import SkeletonCpts from "./routes/SkeletonCpts.svelte";
	import PopupCpts from "./routes/PopupCpts.svelte";
	import PickerCpts from "./routes/PickerCpts.svelte";
	import CarouselCpts from "./routes/CarouselCpts.svelte";
	import SwitchCpts from "./routes/SwitchCpts.svelte";
	import CellCpts from "./routes/CellCpts.svelte";
	import TagCpts from "./routes/TagCpts.svelte";
	import AutoCenterCpts from "./routes/AutoCenterCpts.svelte";
	import TabsCpts from "./routes/TabsCpts.svelte";
	import BadgeCpts from "./routes/BadgeCpts.svelte";
	import GridCpts from "./routes/GridCpts.svelte";
	import SafeAreaCpts from "./routes/SafeAreaCpts.svelte";
	import InputNumberCpts from "./routes/InputNumberCpts.svelte";
	import LoadingCpts from "./routes/LoadingCpts.svelte";
	import RateCpts from "./routes/RateCpts.svelte";
	import NoticeBarCpts from "./routes/NoticeBarCpts.svelte";
	import TextAreaCpts from "./routes/TextAreaCpts.svelte";
	import InputCpts from "./routes/InputCpts.svelte";
	import StepsCpts from "./routes/StepsCpts.svelte";
	import SelectorCpts from "./routes/SelectorCpts.svelte";
	import BannerCpts from "./routes/BannerCpts.svelte";
	import KeyboardCpts from "./routes/KeyboardCpts.svelte";
	import CardCpts from "./routes/CardCpts.svelte";
	import PdfViewerCpts from "./routes/PdfViewerCpts.svelte";
	import ImageCpts from "./routes/ImageCpts.svelte";
	import ProgressCircleCpts from "./routes/ProgressCircleCpts.svelte";
	import SwiperCpts from "./routes/SwiperCpts.svelte";
	const routes = {
		"/": Home,
		"/components/SwiperCpts": SwiperCpts,
		"/components/ProgressCircleCpts": ProgressCircleCpts,
		"/components/ImageCpts": ImageCpts,
		"/components/PdfViewerCpts": PdfViewerCpts,
		"/components/CardCpts": CardCpts,
		"/components/KeyboardCpts": KeyboardCpts,
		"/components/BannerCpts": BannerCpts,
		"/components/ButtonCpts": ButtonCpts,
		"/components/IconCpts": IconCpts,
		"/components/DividerCpts": DividerCpts,
		"/components/IndexBarCpts": IndexBarCpts,
		"/components/AvatarCpts": AvatarCpts,
		"/components/AccordionCpts": AccordionCpts,
		"/components/ToastCpts": ToastCpts,
		"/components/ResultPageCpts": ResultPageCpts,
		"/components/SkeletonCpts": SkeletonCpts,
		"/components/PopupCpts": PopupCpts,
		"/components/PickerCpts": PickerCpts,
		"/components/CarouselCpts": CarouselCpts,
		"/components/SwitchCpts": SwitchCpts,
		"/components/CellCpts": CellCpts,
		"/components/TagCpts": TagCpts,
		"/components/AutoCenterCpts": AutoCenterCpts,
		"/components/TabsCpts": TabsCpts,
		"/components/BadgeCpts": BadgeCpts,
		"/components/GridCpts": GridCpts,
		"/components/SafeAreaCpts": SafeAreaCpts,
		"/components/InputNumberCpts": InputNumberCpts,
		"/components/LoadingCpts": LoadingCpts,
		"/components/RateCpts": RateCpts,
		"/components/NoticeBarCpts": NoticeBarCpts,
		"/components/TextAreaCpts": TextAreaCpts,
		"/components/InputCpts": InputCpts,
		"/components/StepsCpts": StepsCpts,
		"/components/SelectorCpts": SelectorCpts,
	};
</script>

<div class="box">
	<Router {routes} />
</div>

<style>
	.box {
		background-color: #f7f7f7;
	}
</style>
